var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import { mapActions, mapGetters } from "vuex";
import { Loading } from 'element-ui';
import moment from 'moment';
import { billDefaultDate } from "../../helper/defaultDate";
import { UrlHelper } from "../../helper/UrlWrapper";
import OrderService from '../../api/OrderService';
import CommonService from "../../api/CommonService";
import PrintConfigService from "../../api/PrintConfigService";
import { EPurOrderStatus, EShipStatus } from "../../enum/EStatus";
import GlobalVue from "../../globalVue";
import { saveAs } from 'file-saver';
import supplierOrgan from '../supplierorgan/List.vue';
import StoreArchives from '../basicArchives/StoreArchives';
import TakeStockList from '../takeStock/List.vue';
import StockInitList from '../stockInit/List.vue';
import ArticleList from "../../components/alert/ArticleList.vue";
import ArtMsglist from "../../components/alert/ArtMsglist.vue";
import AreaShop from "@/components/AreaShop";
import OrderImportTemplateAdd from '../orderImportTemplate/Add.vue';
import Add from './Add';
import sourceCodePrintList from '../sourceCodePrint/list.vue';
import { EPurOrderErrorCode } from "../../enum/EPurchaseOrderCode";
import BindGoods from '../client/BindGoods.vue';
import PrintSort from '../deliver/PrintSort.vue';
function tidyDepotList(treeData) {
    treeData.forEach(function (item) {
        item.isDisabled = true;
    });
}
var PurOrderHeader = (function (_super) {
    __extends(PurOrderHeader, _super);
    function PurOrderHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.purOrderStatus = EPurOrderStatus;
        _this.formData = {};
        _this.importFormData = {};
        _this.placeHolder = {
            1: '请输入订货单号',
            2: '请输入货品名称',
            10: '请输入客户订货仓库',
            11: '请输入门店名称',
            12: '请选择供应商'
        };
        _this.timeType = [{ label: "预计到货日期", value: "1" }, { label: "订货日期", value: "2" }, { label: "审核日期", value: "3" }];
        _this.eShipStatus = EShipStatus;
        _this.isMoreSearch = false;
        _this.shipStatusList = [{ name: "全部", value: "-1" }, { name: "待发货", value: EShipStatus.NoShip }, { name: "部分发货", value: EShipStatus.PartShip }];
        _this.splitStatusList = [
            { name: "全部", value: -1 },
            { name: "否", value: 0 },
            { name: "是", value: 1 }
        ];
        _this.billsSource = [];
        _this.dialogTableVisible = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = "";
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = "";
        _this.isBatchDelivering = false;
        _this.splitOrderStatus = {
            success: 0,
            client: 1,
            store: 2,
            Inventory: 3,
            begin: 4,
            goods: 8,
            status_update: 76,
        };
        _this.dialogAuditImportVisible = false;
        _this.templateList = [];
        _this.templateDown = {};
        _this.organBusiness = [];
        _this.err_codes = [42, 43, 44, 45];
        _this.logisticsOptions = [];
        _this.selectedLogistics = [];
        _this.supplierList = [];
        _this.purchasingAgentOptions = [];
        _this.formatMsgData = function (data) {
            var result = [];
            for (var orderNumber in data) {
                if (data.hasOwnProperty(orderNumber)) {
                    var products = data[orderNumber].join("、");
                    result.push("{" + orderNumber + "}\u4E2D{" + products + "}");
                }
            }
            return result.join("; ");
        };
        return _this;
    }
    PurOrderHeader.prototype.importTemplateWatch = function (newVal, oldVal) {
        if (newVal != oldVal) {
            var selectedTemp = this.templateList.filter(function (item) { return item.template_id == newVal; });
            this.templateDown = selectedTemp[0] ? selectedTemp[0] :
                {
                    'template_id': -999,
                    'template_url': '/supplierclientapi/purchaseorder/download_valet_poo_template?token=' + this.user.token,
                    'template_name': '初始化模板',
                };
        }
    };
    PurOrderHeader.prototype.statusWatch = function (newVal, oldVal) {
        if ([this.purOrderStatus.Shipped, this.purOrderStatus.Complete, this.purOrderStatus.Invalid].includes(newVal)) {
            this.timeType = [{ label: "预计到货日期", value: "1" }, { label: "订货日期", value: "2" }, { label: "审核日期", value: "3" }, { label: "送货日期", value: "4" }];
        }
        else {
            this.formData.time_type = '4' ? '2' : this.formData.time_type;
            this.timeType = [{ label: "预计到货日期", value: "1" }, { label: "订货日期", value: "2" }, { label: "审核日期", value: "3" }];
        }
        if (newVal == this.purOrderStatus.Shipped) {
            this.getPurchasingAgentOptions();
        }
    };
    PurOrderHeader.prototype.created = function () {
        this.service = OrderService.getInstance();
        this.commonService = CommonService.getInstance();
        this.printConfigService = PrintConfigService.getInstance();
        this.templateDown = {
            'template_id': -999,
            'template_url': '/supplierclientapi/purchaseorder/download_valet_poo_template?token=' + this.user.token,
            'template_name': '初始化模板',
        };
    };
    PurOrderHeader.prototype.mounted = function () {
        this.areaShopComp = this.$refs.areaShopRef;
        this.initData();
        this.getFromSystem();
        this.getSupplierList();
        this.search();
    };
    PurOrderHeader.prototype.initData = function () {
        this.formData = {
            keyword_type: '1',
            keyword: '',
            time_type: "2",
            delivery_status: "-1",
            s_time: billDefaultDate().Start,
            e_time: billDefaultDate().End,
            is_sorting: 0,
            from_system: 0,
            supplier_original_id: [],
            purchasing_agent: [],
        };
        this.selectedLogistics = [];
        this.importFormData = {
            import_template: 0,
            shop_id: null
        };
        this.areaShopComp.resetData();
    };
    PurOrderHeader.prototype.resetData = function () {
        this.initData();
        this.search();
    };
    PurOrderHeader.prototype.downloadTemplate = function (downloadTemplate) {
        try {
            var url = downloadTemplate.template_url;
            saveAs(url.replace(/(http:|https:)([\w\W]+)/, location.protocol + '$2'), "订货单导入模板-" + downloadTemplate.template_name + ".xlsx");
        }
        catch (error) {
            console.error(error);
        }
    };
    PurOrderHeader.prototype.getShop = function (params) {
        var _this = this;
        params = params ? params : {
            type: 1
        };
        this.commonService.getShopFilter(params).then(function (res) {
            if (res.data.success) {
                var depot = res.data.data;
                tidyDepotList(depot);
                _this.organBusiness = depot;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    PurOrderHeader.prototype.getTemplateOptionsList = function () {
        var _this = this;
        this.service.getTemplateOptionsList().then(function (res) {
            _this.templateList = res.data.data || [];
            _this.templateList.push({
                template_id: 0,
                template_name: '初始化模板',
                template_url: '/supplierclientapi/purchaseorder/download_valet_poo_template?token=' + _this.user.token
            });
        });
    };
    PurOrderHeader.prototype.getFromSystem = function () {
        var _this = this;
        this.service.getFromSystem().then(function (res) {
            _this.billsSource = res.data.data || [];
        });
    };
    PurOrderHeader.prototype.getSupplierList = function () {
        var _this = this;
        this.service.getSupplierList().then(function (res) {
            if (res.data.code === 0) {
                _this.supplierList = res.data.data || [];
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message || '获取供应商列表失败');
        });
    };
    PurOrderHeader.prototype.getSupplierLabel = function (item) {
        if (item.business_name) {
            return item.supplier_name + "(" + item.business_name + ")";
        }
        return item.supplier_name;
    };
    PurOrderHeader.prototype.onKeywordTypeChange = function (value) {
        if (value !== '12') {
            this.formData.supplier_original_id = [];
        }
        else {
            this.formData.keyword = '';
        }
    };
    PurOrderHeader.prototype.operateCommand = function (command) {
        switch (command) {
            case 1:
                this.batchEdit();
                break;
            case 2:
                this.printData("single");
                break;
            case 3:
                this.printData("summary");
                break;
        }
    };
    PurOrderHeader.prototype.operateCommand1 = function (command) {
        switch (command) {
            case 1:
                this.importAudit();
                break;
            case 2:
                this.exportData();
                break;
            case 3:
                this.printData();
                break;
            case 4:
                this.discard();
                break;
        }
    };
    PurOrderHeader.prototype.operateCommand2 = function (command) {
        switch (command) {
            case 1:
                this.printData();
                break;
            case 2:
                this.onlyExportData();
                break;
        }
    };
    PurOrderHeader.prototype.operateCommand3 = function (command) {
        switch (command) {
            case 1:
                this.exportData('按客户');
                break;
            case 2:
                this.exportData('按客户门店');
                break;
        }
    };
    PurOrderHeader.prototype.importAudit = function () {
        if (!this.organBusiness.length) {
            this.getShop({ type: 3, freeze: 0 });
        }
        this.getTemplateOptionsList();
        this.dialogAuditImportVisible = true;
        this.setUploadType("beford");
    };
    PurOrderHeader.prototype.batchEdit = function () {
        this.dialogTableVisible = true;
        this.setUploadType("beford");
    };
    PurOrderHeader.prototype.exportGoods = function () {
        var orderIds = this.selectedRows.map(function (item) { return item.order_id; });
        if (!orderIds.length) {
            this.$message.error("请选择订单");
            return;
        }
        ;
        var url = "supplierclientapi/purchaseorder/orders_batch_modify_delivery?order_id=" + orderIds.join(',');
        url = UrlHelper.addParam(url, 'token', this.user.token);
        location.href = url;
    };
    PurOrderHeader.prototype.befordUpload = function (file) {
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (!(fileType && (fileType == "xlsx" || fileType == "xls" || fileType == "csv"))) {
            this.$message.error("文件只能是xlsx或xls");
            return false;
        }
        ;
        if (!this.loadingInstance)
            this.loadingInstance = Loading.service({ fullscreen: true });
    };
    PurOrderHeader.prototype.uploadSuccess = function (response, file, fileList) {
        if (response.success) {
            this.responseSuccess = true;
            var data = response.data;
            this.importSuccessNum = data.success_num;
            this.importFailnum = data.error_num;
            var url = "supplierclientapi/purchaseorder/orders_batch_delivery_error?import_id=" + data.import_id;
            if (this.dialogAuditImportVisible) {
                url = "/basicapi/export_error?import_id=" + data.import_id + "&type=" + data.type;
            }
            url = UrlHelper.addParam(url, 'token', this.user.token);
            this.failDownLoadUrl = url;
            this.search();
        }
        else {
            this.responseFail = true;
            this.errorMsg = response.msg || "网络异常，请重新导入";
            this.$message.error(response.msg);
        }
        this.uploadEnd(response);
    };
    PurOrderHeader.prototype.uploadError = function (err, file, fileList) {
        this.responseFail = true;
        this.errorMsg = err.msg || err.message || "网络异常，请重新导入";
        this.uploadEnd();
    };
    PurOrderHeader.prototype.uploadEnd = function (res) {
        if (!res.success && res.code && res.code == 9999) {
            this.responseFail = false;
            this.errorMsg = "";
            this.setUploadType("beford");
        }
        else {
            this.setUploadType("after");
        }
        this.loadingInstance.close();
    };
    PurOrderHeader.prototype.uploadProgress = function (event, file, fileList) {
        this.setUploadType("importing");
    };
    PurOrderHeader.prototype.setUploadType = function (type) {
        this.befordImport = type == 'beford';
        this.importting = type == 'importing';
        this.afterImport = type == 'after';
    };
    PurOrderHeader.prototype.audit = function (params) {
        var _this = this;
        if (!this.selectedRows || !this.selectedRows.length) {
            this.$message.error("请选择单据");
            return;
        }
        var msg = "\u5BA1\u6838\u540E\uFF0C\u8BA2\u5355\u4E0D\u53EF\u66F4\u6539\uFF0C\u4E14\u9ED8\u8BA4\u4E3A\u5F85\u786E\u8BA4\uFF0C\u8BF7\u786E\u8BA4\u662F\u5426\u7EE7\u7EED\uFF1F";
        this.$confirm(msg, "提示", {
            cancelButtonText: "否",
            confirmButtonText: "是",
            dangerouslyUseHTMLString: true
        }).then(function (res) {
            var orderIds = _this.selectedRows.map(function (item) { return item.order_id; }).join(",");
            var paramsData = {
                ids: params && params.orderIds || orderIds,
                code: params && params.code || '',
                type: params && params.type || ''
            };
            _this.auditAjax(paramsData);
        }).catch(function () { });
    };
    PurOrderHeader.prototype.auditAjax = function (paramsData) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.review(paramsData).then(function (res) {
            var errCode = res.data.code;
            if (_this.err_codes.indexOf(res.data.code) > -1) {
                var instance = _this.$dialog(ArtMsglist, {
                    data: {
                        msgData: res.data.data
                    }
                }, {
                    title: "提示",
                    width: 450,
                    height: 350
                }).instance;
                instance.$on("artMsglist:ok", function (data) {
                    _this.auditAjax({
                        ids: paramsData.ids,
                        code: res.data.code,
                        type: data
                    });
                });
            }
            else {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                    _this.search();
                }
                else {
                    _this.$message.success(res.data.msg || "审核成功");
                    _this.search();
                }
            }
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PurOrderHeader.prototype.discard = function () {
        var _this = this;
        if (!this.selectedRows || !this.selectedRows.length) {
            this.$message.error("请选择单据");
            return;
        }
        var msg = '确定要废弃选中的订单吗？';
        this.$confirm(msg, "提示", {
            cancelButtonText: "否",
            confirmButtonText: "是",
            dangerouslyUseHTMLString: true
        }).then(function (res) {
            var orderIds = _this.selectedRows.map(function (item) { return item.order_id; }).join(",");
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.cancel({
                ids: orderIds
            }).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                }
                else {
                    _this.$message.success({ message: res.data.msg });
                }
                _this.search();
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error({ message: err.msg || err.message });
            });
        }).catch(function () { });
    };
    PurOrderHeader.prototype.addTemp = function () {
        this.dialogAuditImportVisible = false;
        this.getAuth('16004').then(function (pageAuth) {
            GlobalVue.$emit('addTab', {
                component: OrderImportTemplateAdd,
                title: "添加模板",
                showExist: true,
                name: 'template_add',
                cprops: {
                    Root_PageAuth: pageAuth && pageAuth.Auth,
                    root_PageAuth$$: pageAuth && pageAuth.Auth
                }
            });
        });
    };
    PurOrderHeader.prototype.handleSendGoods = function (split_confirm, amount_confirm, stock_confirm, confirm) {
        var _this = this;
        if (split_confirm === void 0) { split_confirm = undefined; }
        if (amount_confirm === void 0) { amount_confirm = undefined; }
        if (stock_confirm === void 0) { stock_confirm = undefined; }
        if (confirm === void 0) { confirm = undefined; }
        if (!this.isBatchDelivering) {
            this.isBatchDelivering = true;
        }
        var orderIds = this.selectedRows.map(function (item) { return item.order_id; }).join(",");
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.mulShip({
            ids: orderIds,
            split_confirm: split_confirm,
            amount_confirm: amount_confirm,
            stock_confirm: stock_confirm,
            confirm: confirm,
        }).then(function (res) {
            loadingInstance.close();
            _this.isBatchDelivering = false;
            if (res.data.code == 67) {
                _this.sendGoodsEqual(res.data, split_confirm, amount_confirm);
                return;
            }
            if (res.data.code == 70) {
                _this.reSendGoods(res.data, split_confirm, amount_confirm);
                return;
            }
            if (res.data.code === 17) {
                var instance = _this.$dialog(ArtMsglist, {
                    data: {
                        msgData: res.data.data,
                        txtColor: "#FF2605"
                    },
                }, {
                    title: '提示',
                    width: 450,
                    height: 350,
                }).instance;
                instance.$on('artMsglist:ok', function (data) {
                    _this.handleSendGoods(split_confirm, amount_confirm, 1, confirm);
                });
                return;
            }
            if (res.data.code === 54) {
                var instance = _this.$dialog(ArtMsglist, {
                    data: {
                        msgData: res.data.data,
                    },
                }, {
                    title: '提示',
                    width: 450,
                    height: 350,
                }).instance;
                instance.$on('artMsglist:ok', function (data) {
                    confirm = res.data.data[0].confirm;
                    _this.handleSendGoods(split_confirm, amount_confirm, 1, confirm);
                });
                return;
            }
            if (res.data.code !== 0) {
                var instance = _this.$dialog(ArticleList, {
                    data: {
                        resData: res.data,
                        sureButtonText: '知道了',
                        modelType: 'deliver',
                    }
                }, {
                    title: "提示",
                    width: 450,
                    height: 350
                }).instance;
                instance.$on("addClient:ok", function (data) {
                    if (res.data.code === 57)
                        _this.search();
                });
                return;
            }
            _this.$message.success(res.data.msg || "批量发货成功");
            _this.search();
            window._czc.push(["_trackEvent", '客户订单发货', '发货', '发货成功']);
        }).catch(function (err) {
            loadingInstance.close();
            _this.isBatchDelivering = false;
            _this.$message.error(err.msg || err.message);
            window._czc.push(["_trackEvent", '客户订单发货', '发货', '发货失败']);
        });
    };
    PurOrderHeader.prototype.sendGoods = function () {
        var _this = this;
        if (this.isBatchDelivering) {
            return;
        }
        if (!this.selectedRows || !this.selectedRows.length) {
            this.$message.error("请选择单据");
            return;
        }
        this.isBatchDelivering = true;
        var msg = '此功能不支持分批发货，选择“是”将发货完毕，<br/>请确认是否继续？';
        this.$confirm(msg, "提示", {
            cancelButtonText: "否",
            confirmButtonText: "是",
            dangerouslyUseHTMLString: true
        }).then(function (res) {
            _this.handleSendGoods();
        }).catch(function () {
            _this.isBatchDelivering = false;
        });
    };
    PurOrderHeader.prototype.reSendGoods = function (res, split_confirm, amount_confirm) {
        var _this = this;
        var text = res.msg.split('？');
        var confirmText = [text[0] + '？', text[1]];
        var newDatas = [];
        var h = this.$createElement;
        for (var i in confirmText) {
            newDatas.push(h('p', null, confirmText[i]));
        }
        this.$confirm('提示', {
            title: '提示',
            message: h('div', null, newDatas),
            confirmButtonText: "是",
            cancelButtonText: "否",
            type: "success",
            showClose: false,
        }).then(function (res) {
            if (res) {
                _this.handleSendGoods(split_confirm, 1);
            }
        }).catch(function (action) {
            if (action === "cancel") {
            }
        });
        return;
    };
    PurOrderHeader.prototype.sendGoodsEqual = function (res, split_confirm, amount_confirm) {
        var _this = this;
        var text = res.msg.split('？');
        var confirmText = [text[0] + '？', text[1]];
        var newDatas = [];
        var h = this.$createElement;
        for (var i in confirmText) {
            newDatas.push(h('p', null, confirmText[i]));
        }
        this.$confirm('提示', {
            title: '提示',
            message: h('div', null, newDatas),
            confirmButtonText: "是",
            cancelButtonText: "否",
            type: "success",
            showClose: false,
        }).then(function (res) {
            if (res) {
                _this.handleSendGoods(1, amount_confirm);
            }
        }).catch(function (action) {
            if (action === "cancel") {
                _this.handleSendGoods(0, amount_confirm);
            }
        });
        return;
    };
    PurOrderHeader.prototype.splitOrders = function () {
        var _this = this;
        if (!this.selectedRows || !this.selectedRows.length) {
            this.$message.error("请选择“未分单”的订单");
            return;
        }
        var orderIds = this.selectedRows.map(function (item) {
            return item.order_id;
        }).join(",");
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.splitOrders({
            order_ids: orderIds
        }).then(function (res) {
            loadingInstance.close();
            if (res.data.code == _this.splitOrderStatus.success) {
                _this.$message.success(res.data.msg || "分单成功");
                _this.search();
                return;
            }
            var confirmdata = {
                confirmButtonText: "确定",
                component: '',
                title: '',
                name: ''
            };
            if (res.data.code == _this.splitOrderStatus.status_update) {
                _this.$message.error(res.data.msg);
                _this.search();
                return;
            }
            else if (res.data.code == _this.splitOrderStatus.client) {
                confirmdata = {
                    confirmButtonText: "去设置",
                    component: supplierOrgan,
                    title: '机构管理',
                    name: '机构管理',
                    authCode: '6009'
                };
            }
            else if (res.data.code == _this.splitOrderStatus.store) {
                confirmdata = {
                    confirmButtonText: "去设置",
                    component: StoreArchives,
                    title: '仓库管理',
                    name: '仓库管理'
                };
            }
            else if (res.data.code == _this.splitOrderStatus.Inventory) {
                confirmdata = {
                    confirmButtonText: "去审核",
                    component: TakeStockList,
                    title: '盘点',
                    name: '盘点',
                    authCode: '210004'
                };
            }
            else if (res.data.code == _this.splitOrderStatus.begin) {
                confirmdata = {
                    confirmButtonText: "去设置",
                    component: StockInitList,
                    title: '库存初始化',
                    name: '库存初始化'
                };
            }
            else if (res.data.code == _this.splitOrderStatus.goods) {
                confirmdata = {
                    confirmButtonText: "去设置",
                    component: Client,
                    title: '合作客户',
                    name: '合作客户'
                };
            }
            if (res.data.code == _this.splitOrderStatus.goods) {
                var instance = _this.$dialog(ArticleList, {
                    data: {
                        resData: res.data
                    }
                }, {
                    title: "提示",
                    width: 450,
                    height: 350
                }).instance;
                instance.$on("addClient:ok", function (data) {
                    GlobalVue.$emit('addTab', {
                        component: confirmdata.component,
                        title: confirmdata.title,
                        showExist: true,
                        name: confirmdata.name,
                        cprops: {}
                    });
                });
                return;
            }
            _this.$confirm(res.data.msg || res.data.message, "提示", {
                confirmButtonText: confirmdata.confirmButtonText,
                showCancelButton: false,
                dangerouslyUseHTMLString: true,
                center: true
            }).then(function (res) {
                if (!confirmdata.component)
                    return;
                if (confirmdata.authCode) {
                    _this.getAuth(confirmdata.authCode).then(function (pageAuth) {
                        GlobalVue.$emit('addTab', {
                            component: confirmdata.component,
                            title: confirmdata.title,
                            showExist: true,
                            name: confirmdata.name,
                            cprops: {
                                Root_PageAuth: pageAuth && pageAuth.Auth,
                                root_PageAuth$$: pageAuth && pageAuth.Auth
                            }
                        });
                    });
                    return;
                }
                GlobalVue.$emit('addTab', {
                    component: confirmdata.component,
                    title: confirmdata.title,
                    showExist: true,
                    name: confirmdata.name,
                    cprops: {}
                });
            });
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PurOrderHeader.prototype.syncOrders = function () {
        var _this = this;
        if (!this.selectedRows || !this.selectedRows.length) {
            this.$message.error("请选择“待确认”的订单");
            return;
        }
        var orderIds = this.selectedRows.map(function (item) {
            return item.order_id;
        }).join(",");
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.syncOrders({
            order_ids: orderIds
        }).then(function (res) {
            loadingInstance.close();
            if (res.data.code == 0) {
                _this.$message.success(res.data.msg || "同步分拣系统成功");
                _this.search();
                return;
            }
            else if (res.data.code == 41) {
                var instance = _this.$dialog(ArtMsglist, {
                    data: {
                        msgData: res.data.data
                    }
                }, {
                    title: "提示",
                    width: 450,
                    height: 350
                }).instance;
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PurOrderHeader.prototype.printData = function (val) {
        return __awaiter(this, void 0, void 0, function () {
            var logistics_type4Len, orderIds, loadingInstance, businessIds, supplierToBusinessIds, params, executePrint;
            var _this = this;
            return __generator(this, function (_a) {
                logistics_type4Len = this.selectedRows.filter(function (item) { return item.logistics_type == 4; }).length;
                orderIds = this.selectedRows.map(function (item) { return item.order_id; });
                if (!orderIds.length) {
                    this.$message.error("请选择订单");
                    return [2];
                }
                loadingInstance = Loading.service({ fullscreen: true });
                businessIds = this.selectedRows.map(function (item) { return item.business_id; });
                businessIds = _.uniq(businessIds);
                supplierToBusinessIds = this.selectedRows.map(function (item) { return item.supplier_to_business_id; });
                supplierToBusinessIds = _.uniq(supplierToBusinessIds);
                params = {
                    template_type: 1,
                    business_id: businessIds.join(','),
                    supplier_to_business_ids: supplierToBusinessIds.join(','),
                };
                executePrint = function () {
                    var url = "./static/js/print/print2.html";
                    if (val == "summary") {
                        url = UrlHelper.addParam(url, 'is_summary', "1");
                    }
                    url = UrlHelper.addParam(url, 'type', "purOrder");
                    url = UrlHelper.addParam(url, 'order_id', orderIds.join(","));
                    url = UrlHelper.addParam(url, 'token', _this.user.token);
                    UrlHelper.windowOpenIntercept(url);
                    window._czc.push(["_trackEvent", '订货单打印', '订货单打印']);
                };
                this.printConfigService.printVerify(params).then(function (res) {
                    loadingInstance.close();
                    if (res.data.code !== 0) {
                        _this.$message.error(res.data.msg || res.data.message);
                        return;
                    }
                    var depotOrderIds = _this.selectedRows
                        .filter(function (item) { return item.logistics_type === 2 && item.depot_in_model === 0; })
                        .map(function (item) { return item.order_id; });
                    var isMsgDialog = false;
                    if (depotOrderIds.length > 0) {
                        _this.service.getPrintNotice({
                            ids: JSON.stringify(depotOrderIds).replace(/^\[|\]$/g, '')
                        }).then(function (res) {
                            var msgData = _this.formatMsgData(res.data.data);
                            isMsgDialog = !!msgData;
                            if (isMsgDialog) {
                                var h_1 = _this.$createElement;
                                var msgElements = msgData.split("; ").map(function (item) { return h_1('p', null, item); });
                                _this.$msgbox({
                                    title: '提示',
                                    message: h_1('div', null, [
                                        h_1('span', null, '因餐饮采购员生成订单下发给供应商时，修改了该货品的总订货数量，导致门店订货明细数量之和不等于货品的总订货数量；明细数据仅供参考，是否继续打印？'),
                                        h_1('p', null, "涉及单据货品：")
                                    ].concat(msgElements)),
                                    showCancelButton: true,
                                    confirmButtonText: '继续打印',
                                    cancelButtonText: '取消',
                                    beforeClose: function (action, instance, done) {
                                        if (action === 'confirm') {
                                            done();
                                            executePrint();
                                        }
                                        else {
                                            done();
                                        }
                                    }
                                });
                            }
                            else {
                                executePrint();
                            }
                        }, function (err) {
                            _this.$message.error(err.message || err.msg);
                        });
                    }
                    else {
                        executePrint();
                    }
                }, function (err) {
                    loadingInstance.close();
                    _this.$message.error(err.message || err.msg);
                });
                return [2];
            });
        });
    };
    PurOrderHeader.prototype.onlyExportData = function () {
        var orderIds = [], clientIds = {};
        this.selectedRows.forEach(function (item) {
            orderIds.push(item.order_id);
            if (!clientIds[item.business_id]) {
                clientIds[item.business_id] = item.business_id;
            }
            ;
        });
        this.exportBill(orderIds, 0);
    };
    PurOrderHeader.prototype.exportData = function (val) {
        var orderIds = [], clientIds = {};
        this.selectedRows.forEach(function (item) {
            orderIds.push(item.order_id);
            if (!clientIds[item.business_id]) {
                clientIds[item.business_id] = item.business_id;
            }
            ;
        });
        var is_summary = 0;
        var type = 1;
        if (this.status == this.purOrderStatus.Bship) {
            if (val && val == "按客户") {
                type = 2;
            }
            else if (val && val == "按客户门店") {
                type = 1;
            }
            is_summary = 1;
            this.exportBill(orderIds, is_summary, type);
        }
        else {
            this.exportBill(orderIds, is_summary);
        }
    };
    PurOrderHeader.prototype.exportBill = function (orderIds, is_summary, type) {
        var _this = this;
        if (this.status == this.purOrderStatus.Bship) {
            window._czc.push(["_trackEvent", '客户订货汇总导出', '汇总导出']);
        }
        else {
            window._czc.push(["_trackEvent", '订货单导出', '订货单导出']);
        }
        var url = "";
        if (this.status == this.purOrderStatus.Bship && type) {
            url = "supplierclientapi/purchaseorder/export_order?ids=" + orderIds.join(",") + "&is_summary=" + is_summary + "&type=" + type;
        }
        else {
            url = "supplierclientapi/purchaseorder/export_order?ids=" + orderIds.join(",") + "&is_summary=" + is_summary;
        }
        url = UrlHelper.addParam(url, 'token', this.user.token);
        var filter = {
            order_sup_status: this.status,
        };
        Object.assign(filter, this.formData);
        if (filter['s_time']) {
            filter['s_time'] = moment(filter['s_time']).format('YYYY-MM-DD HH:mm:ss');
        }
        if (filter['e_time']) {
            filter['e_time'] = moment(filter['e_time']).format('YYYY-MM-DD HH:mm:ss');
        }
        for (var key in filter) {
            filter[key] = (filter[key] === undefined || filter[key] === null) ? '' : filter[key];
            url = UrlHelper.addParam(url, key, filter[key]);
        }
        this.commonService.exportCheck(url)
            .then(function (res) {
            location.href = url;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PurOrderHeader.prototype.resetFormData = function () {
        var areaShopFormData = this.$refs.areaShopRef.getFormData();
        this.formData = _.extend(this.formData, areaShopFormData);
    };
    PurOrderHeader.prototype.search = function () {
        this.resetFormData();
        this.formData.logistics_name = this.selectedLogistics.join(',');
        var searchData = __assign({}, this.formData);
        if (Array.isArray(searchData.supplier_original_id)) {
            searchData.supplier_original_id = searchData.supplier_original_id.join(',');
        }
        if (Array.isArray(searchData.purchasing_agent)) {
            searchData.purchasing_agent = searchData.purchasing_agent.join(',');
        }
        if (searchData.s_time) {
            searchData.s_time = moment(searchData.s_time).format('YYYY-MM-DD HH:mm:ss');
        }
        if (searchData.e_time) {
            searchData.e_time = moment(searchData.e_time).format('YYYY-MM-DD HH:mm:ss');
        }
        this.$emit('search', searchData);
        if (this.formData.keyword_type == 1) {
            window._czc.push(["_trackEvent", '客户订货搜索类型', '客户订货搜索类型', '按单号搜索']);
        }
        else if (this.formData.keyword_type == 2) {
            window._czc.push(["_trackEvent", '客户订货搜索类型', '客户订货搜索类型', '按货品搜索']);
        }
    };
    PurOrderHeader.prototype.confirmMul = function () {
        this.$emit("confirm");
    };
    PurOrderHeader.prototype.generatePurchasePlan = function () {
        var _this = this;
        if (!this.selectedRows || !this.selectedRows.length) {
            this.$message.error("请选择“待确认”的订单");
            return;
        }
        var orderIds = this.selectedRows.map(function (item) { return item.order_id; }).join(",");
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.generatePurchasePlan({
            order_ids: orderIds
        }).then(function (res) {
            loadingInstance.close();
            if (res.data.code == 0) {
                _this.$message.success(res.data.msg || "生成订购计划成功");
                _this.search();
                return;
            }
            var instance = _this.$dialog(ArticleList, {
                data: {
                    resData: res.data,
                    sureButtonText: '去绑定',
                    modelType: 'deliver',
                }
            }, {
                title: "提示",
                width: 450,
                height: 350
            }).instance;
            instance.$on("addClient:ok", function (data) {
                console.log(222, res.data.code);
                if (res.data.code == EPurOrderErrorCode.BUSINESS_GOODS_NOT_BIND) {
                    var good_code = void 0;
                    var business_id = _this.selectedRows.map(function (item) { return item.business_id; }).join(",");
                    var supplier_to_business_id = _this.selectedRows.map(function (item) { return item.supplier_to_business_id; }).join(",");
                    GlobalVue.$emit("addTab", {
                        component: BindGoods,
                        title: '绑定货品',
                        showExist: true,
                        name: 'bindGoods_' + business_id,
                        cprops: {
                            clientIds: business_id,
                            business_id: business_id,
                            supplier_to_business_id: supplier_to_business_id,
                            supplierToBusinessIds: supplier_to_business_id,
                            good_code: good_code
                        }
                    });
                }
            });
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PurOrderHeader.prototype.moreSearchComShow = function () {
        this.isMoreSearch = true;
        this.getLogisticsOptions();
        this.getPurchasingAgentOptions();
        this.areaShopComp.getArea();
        window._czc.push(["_trackEvent", '客户订货高级查询', '高级查询展开']);
    };
    PurOrderHeader.prototype.getLogisticsOptions = function () {
        var _this = this;
        this.commonService.getLogisticsAllOptions().then(function (res) {
            if (res.data.success) {
                _this.logisticsOptions = res.data.data || [];
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PurOrderHeader.prototype.getPurchasingAgentOptions = function () {
        var _this = this;
        this.service.getPurchasingAgentOptions().then(function (res) {
            if (res.data.code === 0) {
                _this.purchasingAgentOptions = res.data.data || [];
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PurOrderHeader.prototype.moreSearchComHide = function () {
        this.isMoreSearch = false;
        window._czc.push(["_trackEvent", '客户订货高级查询', '高级查询收起']);
    };
    PurOrderHeader.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    PurOrderHeader.prototype.add = function () {
        this.addTab({
            component: Add,
            title: '添加订货单',
            showExist: true,
            name: 'purchaseorder_add',
            cprops: {}
        });
    };
    PurOrderHeader.prototype.normalizer = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    PurOrderHeader.prototype.closeTab = function () {
        var closeBtnArr = $(".navTabsCloseBtn").prev();
        for (var i = 0; i < closeBtnArr.length; i++) {
            if ($(closeBtnArr[i])[0].innerText == "溯源码打印") {
                console.log($(closeBtnArr[i]).next());
                $(closeBtnArr[i]).next().click();
            }
        }
    };
    PurOrderHeader.prototype.sourceCodePrint = function () {
        this.closeTab();
        var orderIds = this.selectedRows.map(function (item) { return item.order_id; });
        var orderSources = this.selectedRows.map(function (item) { return item.from_system_name; });
        var orderCustomers = this.selectedRows.map(function (item) { return item.customer; });
        if (!orderIds.length) {
            this.$message.error("请选择订单");
            return;
        }
        if (orderIds.length > 20) {
            this.$message.error("最多选择20条订单！");
            return;
        }
        var sourceTemp = orderSources[0], sourceFlag = false, customerTemp = orderCustomers[0], customerFlag = false;
        orderSources.forEach(function (item) {
            if (item !== sourceTemp) {
                sourceFlag = true;
            }
        });
        orderCustomers.forEach(function (item) {
            if (item !== customerTemp) {
                customerFlag = true;
            }
        });
        if (sourceFlag) {
            this.$message.error("请选择单据来源是供应链客户且同一客户的订货单!");
            return;
        }
        if (customerFlag) {
            this.$message.error("请选择单据来源是供应链客户且同一客户的订货单!");
            return;
        }
        var supplierToBusinessId = this.selectedRows.map(function (item) { return item.supplier_to_business_id; });
        if (_.uniq(supplierToBusinessId).length > 1) {
            this.$message.error("请选择单据来源是供应链客户且同一客户的订货单!");
            return;
        }
        if (this.selectedRows[0].from_system != 1) {
            this.$message.error("请选择单据来源是供应链客户且同一客户的订货单!");
            return;
        }
        sessionStorage.setItem("sourceCodeType", "purchase");
        this.addTab({
            component: sourceCodePrintList,
            title: '溯源码打印',
            showExist: true,
            name: 'source_list',
            cprops: {
                orderIds: orderIds.join(","),
                orderSources: sourceTemp,
                orderCustomers: customerTemp,
                business_id: this.selectedRows[0].business_id,
                supplier_to_business_id: this.selectedRows[0].supplier_to_business_id
            },
        });
    };
    PurOrderHeader.prototype.sortingTagPrint = function () {
        var _this = this;
        var orderIds = this.selectedRows.map(function (item) { return item.order_id; });
        if (!orderIds.length) {
            this.$message.error("请选择订单");
            return;
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        var businessIds = this.selectedRows.map(function (item) { return item.business_id; });
        var supplierTobusinessIds = this.selectedRows.map(function (item) { return item.supplier_to_business_id; });
        businessIds = _.uniq(businessIds);
        var params = {
            template_type: 21,
            business_id: businessIds.join(','),
            supplier_to_business_ids: supplierTobusinessIds.join(','),
        };
        this.printConfigService.printVerify(params).then(function (res) {
            loadingInstance.close();
            _this.addTab({
                component: PrintSort,
                title: '分拣标签打印',
                showExist: true,
                name: 'print_sort_purchaseorder',
                cprops: {
                    orderIds: orderIds.join(","),
                    type: 1
                },
                callback: function (result) {
                    if (result && result.comp && result.comp.getList) {
                        result.comp.orderIds = orderIds.join(",");
                        result.comp.getList();
                    }
                }
            });
        }, function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    PurOrderHeader.prototype.logisticPrint = function () {
        var orderIds = this.selectedRows.map(function (item) { return item.order_id; });
        if (!orderIds.length) {
            this.$message.error("请选择订单");
            return;
        }
        var url = "./static/js/print/print2.html";
        url = UrlHelper.addParam(url, 'type', "LogisticPrint");
        url = UrlHelper.addParam(url, 'order_id', orderIds.join(","));
        url = UrlHelper.addParam(url, 'token', this.user.token);
        UrlHelper.windowOpenIntercept(url);
        window._czc.push(["_trackEvent", '客户订货已发货', '物流单打印']);
    };
    __decorate([
        Prop({
            default: 1,
            type: String
        })
    ], PurOrderHeader.prototype, "status", void 0);
    __decorate([
        Prop({
            type: Array,
            default: []
        })
    ], PurOrderHeader.prototype, "selectedRows", void 0);
    __decorate([
        Watch("importFormData.import_template")
    ], PurOrderHeader.prototype, "importTemplateWatch", null);
    __decorate([
        Watch("status")
    ], PurOrderHeader.prototype, "statusWatch", null);
    PurOrderHeader = __decorate([
        Component({
            methods: __assign({}, mapActions(["getAuth"])),
            computed: __assign({}, mapGetters({
                "user": "user",
                "openedCodeData": 'openedCodeData',
                "ediStatus": 'ediStatus'
            })),
            components: {
                "areaShop": AreaShop
            }
        })
    ], PurOrderHeader);
    return PurOrderHeader;
}(Vue));
export default PurOrderHeader;
